export class URL {
    private static isRedirecting = false;

    public static getStaticsUrl() {
        return $('[name=staticsBaseUrl]').val();
    }

    public static getUrlData() {
        const [, , locationId, tableNumber] = window.location.pathname.split('/');

        return [locationId, decodeURIComponent(tableNumber)];
    }

    public static getHashValue(key: string) {
        const matches = window.location.hash.match(new RegExp(`${key}=([^&]*)`));
        return matches ? matches[1] : undefined;
    }

    public static goto(url: string) {
        if (URL.isRedirecting) {
            return;
        }

        if (!url.startsWith('#')) {
            URL.isRedirecting = true;
        }

        window.location.href = url;
    }

    public static getQueryParams<T>(): T | undefined {
        const search = window.location.search.substring(1);
        try {
            return JSON.parse(`{"${search.replace(/&/g, '","')
                .replace(/=/g, '":"')}"}`, (key, value) => (key === '' ? value : decodeURIComponent(value)));
        } catch (e) {
            return undefined;
        }
    }
}
